<template>
    <pick-list :label="labelUsuario" v-model="usuario"
        :title="picklistUsuarioTitle"
        :columns="picklistUsuarioColumns"
        :search_OnClick="btnSearch_OnClick"
        :formatSelection="picklist_formatSelection"
        :hint="hintMessage"
        :readonly="readonly"
        :required="required"
        :rules="getRules"                   
        itemKey="id">

        <v-container fill-height fluid grid-list-xl>
            <v-layout wrap>
                <v-flex sm12 xs12 md12 lg12 grid-list-md>
                    <v-container py-0>
                        <v-layout wrap>         
                            <v-flex xs12 md6>
                                <v-select :label="cboPais" :items="listaPaises" return-object v-model="paisComputed"
                                    item-value="id" item-text="nome" :no-data-text="cboPaisSemDados"
                                    :rules="searchRule.pais"></v-select>                
                            </v-flex>

                            <v-flex xs12 md6 v-show="pais != null">
                                <v-text-field v-mask="mascaraDocumento" v-model.trim="documento"
                                    :label="labelDocumento" :rules="searchRule.documento"/>         
                            </v-flex>       

                            <v-flex xs12 md6>
                                <v-text-field v-model="primeiroNome" :label="labelPrimeiroNome"
                                    :rules="searchRule.primeiroNome"/>
                            </v-flex>

                            <v-flex xs12 md6>
                                <v-text-field v-model="ultimoNome" :label="labelUltimoNome"
                                    :rules="searchRule.ultimoNome"/>
                            </v-flex>       

                            <v-flex xs12 md6>
                                <v-text-field v-model="login" :label="labelLogin"
                                    :rules="searchRule.login"/>            
                            </v-flex>

                            <v-flex xs12 md6>
                                <v-text-field v-model="email" :label="labelEmail"
                                    :rules="searchRule.email"/>             
                            </v-flex>                                                                                         
                        </v-layout>
                    </v-container>  
                </v-flex>            
            </v-layout> 
        </v-container>
    </pick-list>
</template>

<script>
import FormMixin from '@/mixin/form'
import PickList from '@/components/material/PickList'

import ColaboradorApi from '@/api/workspace/success-factors/colaborador'
import PaisApi from '@/api/workspace/corporativo/pais'

import DocumentoMixin from '@/mixin/documento'

import { mask }  from 'vue-the-mask'
import { mapGetters } from 'vuex'

export default {  
    mixins: [ DocumentoMixin, FormMixin ],      
    directives: { mask },   
    components: {
        "pick-list": PickList
    },     
    props:{    
        readonly:{
            required: false, 
            default: false,
            type: Boolean   
        },    
        required:{
            required: false, 
            default: false,
            type: Boolean   
        }, 
        rules:{
            required: false, 
            type: Array   
        },                
        title:{
            required: false, 
            type: String
        },
        label:{
            required: false, 
            type: String
        },
        value:{
            required: false,
            type: Object
        }
    },
    watch:{
        usuario(newValue, oldValue){
            if(newValue != oldValue){
                this.$emit("input", newValue);
            }
        },        
        value(newValue, oldValue){
            if(newValue != oldValue){
                this.usuario = newValue;
            }
        }
    },    
    data () {
        return { 
            pais: null,
            paisPadraoUsuario: false,
            listaPaises: [],
            primeiroNome: null,
            ultimoNome: null,
            email: null, 
            login: null,
            documento: null,
            usuario: null,
            hintMessage: null,
            searchRule: {
                pais: [
                    val => {
                        if(this.$_.trim(this.login) == "" && this.$_.trim(this.email) == ""){
                            if(val == null || val == undefined){
                                return this.$t('Core.SuccessFactors.Usuario.PickList.pais-obrigatorio');
                            }             
                        }

                        return true;
                    }
                ],
                documento:[
                    val => {
                        if(this.$_.trim(this.login) == "" && this.$_.trim(this.email) == ""){
                            if(this.$_.trim(this.primeiroNome) == "" && this.$_.trim(this.ultimoNome) == "" && this.$_.trim(val) == ""){
                                return this.$t('Core.SuccessFactors.Usuario.PickList.campos-pesquisa-obrigatorio');
                            }             
                        }

                        return true;
                    }
                ], 
                primeiroNome:[
                    val => {
                        if(this.$_.trim(this.login) == "" && this.$_.trim(this.email) == ""){
                            if(this.$_.trim(this.documento) == "" && this.$_.trim(val) == ""){
                                return this.$t('Core.SuccessFactors.Usuario.PickList.campos-pesquisa-obrigatorio');
                            }             
                        }

                        return true;
                    }
                ], 
                ultimoNome:[
                    val => {
                        if(this.$_.trim(this.login) == "" && this.$_.trim(this.email) == ""){
                            if(this.$_.trim(this.documento) == "" && this.$_.trim(val) == ""){
                                return this.$t('Core.SuccessFactors.Usuario.PickList.campos-pesquisa-obrigatorio');
                            }             
                        }

                        return true;
                    }
                ],                                 
                login:[
                    val => {
                        if(
                            this.$_.trim(this.login) == "" && this.$_.trim(this.email) == "" &&
                            this.$_.trim(this.primeiroNome) == "" && this.$_.trim(this.ultimoNome) == "" &&
                            this.$_.trim(this.documento) == ""
                        ){
                            if(val == null || val == undefined){
                                return this.$t('Core.SuccessFactors.Usuario.PickList.campos-pesquisa-opcionais');
                            }             
                        }

                        return true;
                    }
                ],                                 
                email:[
                    val => {
                        if(
                            this.$_.trim(this.login) == "" && this.$_.trim(this.email) == "" &&
                            this.$_.trim(this.primeiroNome) == "" && this.$_.trim(this.ultimoNome) == "" &&
                            this.$_.trim(this.documento) == ""
                        ){
                            if(val == null || val == undefined){
                                return this.$t('Core.SuccessFactors.Usuario.PickList.campos-pesquisa-opcionais');
                            }             
                        }

                        return true;
                    }
                ]                      
            }
        }
    },     
    async mounted(){
        await this.listarPaises();
    },
    computed: { 
        ...mapGetters("app", ["getUserCountry"]),
        labelPrimeiroNome () {
            return this.$t('Core.SuccessFactors.Usuario.PickList.primeiro-nome');
        },   
        labelUltimoNome () {
            return this.$t('Core.SuccessFactors.Usuario.PickList.ultimo-nome');
        },                           
        labelUsuario () {
            if(this.label == null)
                return this.$t('Core.SuccessFactors.Usuario.PickList.usuario');
            else 
                return this.label;            
        },
        picklistUsuarioColumns(){
            return [
                { text: this.$t('Core.SuccessFactors.Usuario.PickList.pais'), align: 'center', value: 'pais.nome' },
                { text: this.$t('Core.SuccessFactors.Usuario.PickList.nome-completo'), align: 'left', value: 'nomeCompleto' },
                { text: this.$t('Core.SuccessFactors.Usuario.PickList.cargo'), align: 'left', value: 'cargo.nome' },
            ];            
        },
        picklistUsuarioTitle(){
            if(this.title == null)
                return this.$t('Core.SuccessFactors.Usuario.PickList.title');
            else 
                return this.title;
        },
        cboPais(){
            return this.$t('Core.SuccessFactors.Usuario.PickList.pais');
        },           
        cboPaisSemDados(){
            return this.$t('Core.SuccessFactors.Usuario.PickList.nenhum-pais-encontrado');
        },        
        paisComputed: {
            get(){
                if(this.pais == null && this.getUserCountry != null && !this.paisPadraoUsuario){
                    this.$set(this, "paisPadraoUsuario", true);
                    this.$set(this, "pais", this.getUserCountry);
                }

                return this.pais;
            },
            set(value){
                this.$set(this, "pais", value);
            }
        },           
        listarSubordinados(){
            return this.$t('Core.SuccessFactors.Usuario.PickList.listar-subordinados');
        },
        labelDocumento(){
            if(this.pais == null) return null;
            return this.$t(`Core.SuccessFactors.Usuario.PickList.documento-${this.pais.codigoDuasLetrasSuccessFactors}`)
        },     
        mascaraDocumento(){
            if(this.pais == null)
                return "";
            
            else{
                return this.retornarMascaraDocumentoPrincipal(this.pais);
            }
        },                                               
        labelLogin(){
            return this.$t('Core.SuccessFactors.Usuario.PickList.login');
        },    
        labelEmail(){
            return this.$t('Core.SuccessFactors.Usuario.PickList.email');
        },         
        getRules(){
            if((this.rules || []).length > 0){
                return this.rules;
            }
            else{
                if(this.required == true){
                    return [
                        val => {
                            if((val || null) == null)
                                return this.$t("Core.SuccessFactors.Usuario.PickList.usuario-obrigatorio");

                            return true;
                        }
                    ];
                }
            }

            return [];
        },            
    },   
    methods:{  
        async listarPaises(){
            let pais = await PaisApi.listar();
            this.listaPaises = [];

            if(pais.success && pais.data.length > 0)
                this.listaPaises = pais.data;

            if(this.pais == null && this.getUserCountry != null){
                this.$set(this, "pais", this.getUserCountry);
            }                
        },
        async btnSearch_OnClick(){
            let listaUsuario = null;
            if(this.$_.trim(this.documento) != ""){
                listaUsuario = await ColaboradorApi.listarPorDocumento(this.pais, this.documento);

                this.$set(this, "primeiroNome", null);
                this.$set(this, "ultimoNome", null);

                this.$set(this, "login", null);
                this.$set(this, "email", null);
            }
            else if(this.$_.trim(this.login) != "")
            {
                listaUsuario = await ColaboradorApi.listarPorLogin(this.login);

                this.$set(this, "primeiroNome", null);
                this.$set(this, "ultimoNome", null);

                this.$set(this, "email", null);
                this.$set(this, "documento", null);
            }
            else if(this.$_.trim(this.email) != "")
            {
                listaUsuario = await ColaboradorApi.listarPorEmail(this.email);

                this.$set(this, "primeiroNome", null);
                this.$set(this, "ultimoNome", null);

                this.$set(this, "login", null);
                this.$set(this, "documento", null);
            }            
            else{
                listaUsuario = await ColaboradorApi.listarNome(this.pais, this.primeiroNome, this.ultimoNome);

                this.$set(this, "primeiroNome", null);
                this.$set(this, "ultimoNome", null);

                this.$set(this, "documento", null);
                this.$set(this, "login", null);

                this.$set(this, "email", null);
            }

            if(listaUsuario != null && listaUsuario.success)
                return [ listaUsuario.data ];

            return [];
        },    
        picklist_formatSelection(usuario){
            if(usuario == null){
                this.hintMessage = null;
                return null;
            }
            else if(usuario.cargo == null){
                this.hintMessage = null;
                return `${usuario.nomeCompleto} (?)`            
            }
                
            this.hintMessage = usuario.cargo.descricao;
            return `${usuario.nomeCompleto} (${usuario.cargo.nome})`            
        },               
    },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/material-dashboard/variables";

</style>
